import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to fetch widget embed script
 *
 * @example
 * const { data, isLoading, error } = useWidgetEmbedScript(channelId);
 */
export const useWidgetEmbedScript = (channelId: string | undefined) => {
  return useQuery({
    queryKey: ['widget-embed-script', channelId],
    queryFn: () => channelsApi.getWidgetEmbedScript(channelId!),
    enabled: !!channelId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};
